import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const items = ['Recién terminaste la universidad y la práctica real no se parece a lo que estudiaste', 'Llegas a casa después de las sesiones y todavía tienes que preparar el material de mañana', 'Buscas protocolos en grupos de WhatsApp de colegas y en PDFs en inglés que tienes que adaptar', 'Llegas a una sesión y en el fondo no estás seguro/a de que lo que estás haciendo es lo más correcto', 'El paciente te pregunta cuántas sesiones más necesita y respondes "depende" porque no tienes un protocolo claro', 'Sabes que deberías cobrar más pero no tienes idea de cuánto debería ser ese número', 'Quieres que tu práctica proyecte la seguridad de alguien que sabe exactamente lo que hace'];
export function Checklist() {
  return <section className="py-16 md:py-24 px-4 bg-brand-teal text-white" data-id="element-31">
      <div className="max-w-4xl mx-auto" data-id="element-32">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-33">
          Este sistema es para ti si...
        </h2>

        <div className="space-y-6" data-id="element-34">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-brand-dark/30 p-4 md:p-6 rounded-xl" data-id="element-35">
              <CheckCircle2 className="text-brand-amber flex-shrink-0 mt-1" size={24} data-id="element-36" />
              <p className="text-lg md:text-xl font-medium leading-relaxed" data-id="element-37">
                {item}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}